import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RecapPage from '../components/Recap/RecapPage';

export const PrivateRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => (
    <Route {...rest} component={(props) => (
      JSON.parse(sessionStorage.getItem('auth'))
        && JSON.parse(sessionStorage.getItem('auth')).uid ? (
          <div>
            <Header showMenu={props.match.path != '/cgu/:id'}/>
            {JSON.parse(sessionStorage.getItem('auth')).role === 'MC'
              && props.match.path != '/cgu/:id' ?
              <RecapPage {...props} />
              :
              <Component {...props} />
            }
            <Footer />
          </div>
        ) : (
          <Redirect to="/" />
        )
    )} />
  );
const mapStateToProps = (state) => ({
  isAuthenticated: !!state.auth.uid
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js